/**
 * Explore (legacy) page — filter state <-> URL sync (ISP-9999
 * stgport-locked-wheel-goback-origin-discover-filters-content-behind).
 *
 * Pure, DB-free helpers, one per filter, mirroring the pattern dev's
 * ExploreV2 page already uses (sortUrlSync.js/categoryUrlSync.js/
 * searchUrlSync.js/tagUrlSync.js) — this legacy page had NONE of that, so
 * every filter (sort/search/multi-select filters/content type) lived only
 * in local React state. Navigating away (e.g. into a locked wheel) and back
 * via Go Back / browser Back unmounted this page and lost all of it.
 *
 * Read functions never trust a hand-edited URL: an unrecognized value falls
 * back to the same default the state itself already used.
 */
import { MENU_OPTIONS, WHEEL_FILTERS, CONTENT_TYPE_FILTERS } from "./constants";

const SORT_VALUES = MENU_OPTIONS.map((o) => o.value);
const DEFAULT_SORT = MENU_OPTIONS[0].value;

const FILTER_VALUES = WHEEL_FILTERS.map((o) => o.value);

const CONTENT_TYPE_VALUES = CONTENT_TYPE_FILTERS.map((o) => o.value);
const DEFAULT_CONTENT_TYPE = CONTENT_TYPE_FILTERS[0].value;

const SEARCH_MAX_LENGTH = 200;

/** Sort ---------------------------------------------------------------- */
export const readSortFromParams = (searchParams) => {
  const raw = searchParams.get("sort");
  return SORT_VALUES.includes(raw) ? raw : DEFAULT_SORT;
};

export const writeSortToParams = (prevParams, sort) => {
  const params = new URLSearchParams(prevParams);
  if (!sort || sort === DEFAULT_SORT) {
    params.delete("sort");
  } else {
    params.set("sort", sort);
  }
  return params;
};

/** Search ---------------------------------------------------------------- */
export const readSearchFromParams = (searchParams) =>
  (searchParams.get("search") || "").slice(0, SEARCH_MAX_LENGTH);

export const writeSearchToParams = (prevParams, search) => {
  const params = new URLSearchParams(prevParams);
  const trimmed = (search || "").slice(0, SEARCH_MAX_LENGTH).trim();
  if (!trimmed) {
    params.delete("search");
  } else {
    params.set("search", (search || "").slice(0, SEARCH_MAX_LENGTH));
  }
  return params;
};

/** Multi-select wheel filters (ANY-OF/OR, repeated ?filter=<value>) ----- */
export const readFiltersFromParams = (searchParams) => {
  const seen = new Set();
  const result = [];
  searchParams.getAll("filter").forEach((raw) => {
    if (!FILTER_VALUES.includes(raw) || seen.has(raw)) return;
    seen.add(raw);
    result.push(raw);
  });
  return result;
};

export const writeFiltersToParams = (prevParams, filterValues) => {
  const params = new URLSearchParams(prevParams);
  params.delete("filter");
  (filterValues || []).forEach((v) => {
    if (FILTER_VALUES.includes(v)) params.append("filter", v);
  });
  return params;
};

/** Content type (Wheels/Users) ------------------------------------------ */
export const readContentTypeFromParams = (searchParams) => {
  const raw = searchParams.get("type");
  return CONTENT_TYPE_VALUES.includes(raw) ? raw : DEFAULT_CONTENT_TYPE;
};

export const writeContentTypeToParams = (prevParams, contentType) => {
  const params = new URLSearchParams(prevParams);
  if (!contentType || contentType === DEFAULT_CONTENT_TYPE) {
    params.delete("type");
  } else {
    params.set("type", contentType);
  }
  return params;
};
